import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

import { ModifiedSkillsByClass } from './types';

interface DestroyConfig extends AxiosRequestConfig {
  method: 'DELETE';
  url: `/classes/${string}/assignments/${string}`;
  params: { 'remove-skills-from-sr': boolean };
}

export interface KlassAssignmentDestroyResponse {
  modifiedSkillsByClass: ModifiedSkillsByClass;
}

/**
 * DELETE /vo/v1/classes/{class_id}/assignments/{aic_id}?remove-skills-from-sr={remove_skills_from_sr}
 */
export const destroy = (
  classId: string,
  aicId: string,
  removeSkillsFromSR: boolean,
): DestroyConfig => {
  return {
    baseURL: BASE_API,
    method: 'DELETE',
    url: `/classes/${classId}/assignments/${aicId}`,
    params: { 'remove-skills-from-sr': removeSkillsFromSR },
  } as const;
};
